<template>
    <el-card @click.native="verCapa(card)" class="card-capa" :body-style="{ padding: '0px' }">
        <img :src="card.imagen_url" class="image">
        <div class="card-content">
            <div class="text-content">
                <div class="nombre">{{ card.nombre }}</div>
                <div class="direccion">{{ card.nombre_direccion }}</div>
                <div class="modalidad">{{ card.modalidad }}
                </div>
                <div :class="parseInt(card.tieneComisionesActivas) ? 'comisiones-a' : 'comisiones-c' ">{{
                    getTextoBoton(card) }}
                </div>
                <!-- <div v-if="card.proxima_fecha_preinscripcion">
                    <span class="el-icon-date"></span> {{ card.proxima_fecha_preinscripcion }}
                </div> -->
            </div>

            <div class="boton">

                <el-button type="primary" size="default" @click.stop="verCapa(card)">VER
                    DETALLES </el-button>

            </div>
        </div>
    </el-card>
</template>

<script>
export default {
    name: 'CustomCard',
    props: {
        card: {
            type: Object,
            required: true
        }
    },
    methods: {
        getTextoBoton(capa)
        {
            if (capa.tieneComisionesActivas !== '0' && capa.tieneComisionesActivas )
                {
                    return 'Preinscripciones abiertas'
                }
                else{
                return capa.hasActiveComision ? 'Inscripciones disponibles' : 'Próximamente' 
                }
           
        },
        verCapa(capa) {
            // console.log('verCapa',id);
            this.$router.push({ name: 'detalleCapa', params: { token:capa.token, nombre:capa.slug } })
        }
    }
}
</script>

<style scoped>

.card-capa {
    border: 1px solid #ccc;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    font-family: 'Roboto', sans-serif;
    /* display: flex; */
    /* Cambio clave: Flexbox para la tarjeta */
    flex-direction: column;
    /* Cambio clave: Dirección de columna */
    display: flex;
  flex-direction: column;
  height: 100%; /* Nuevo: Asegurar altura completa */
  cursor: pointer;
  transition: all 0.2s;
 
 
}
.card-capa:hover{
 transform: scale(1.01);
}

.image {
    width: 100%;
    height: auto;
}

.card-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 16px;
    flex-grow: 1;
    min-height: 250px;
    transition: all 0.2s;
}

.text-content {
    flex-grow: 1;
}

.nombre {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 8px;
}

.direccion {
    font-size: 14px;
    color: #03A9F4;
    margin-bottom: 8px;
}

.modalidad {
    display: inline-block;
    background-color: #17a2b8;
    color: #fff;
    padding: 6px 12px;
    border-radius: 2px;
    margin-bottom: 5px;
    margin-right: 5px;
    font-size: 14px;
}
.comisiones-a {
    display: inline-block;
    background-color: #47aa05;
    color: #fff;
    padding: 6px 12px;
    border-radius: 2px;
    margin-bottom: 16px;
    margin-left: 0px;
    font-size: 14px;
}
.comisiones-c {
    display: inline-block;
    background-color: #FFC107;
    color: #fff;
    padding: 6px 12px;
    border-radius: 2px;
    margin-bottom: 16px;
    margin-left: 0px;
    font-size: 14px;
}

.boton {
    position: relative;
    width: 100%;
    /* Cambio clave: Ancho completo para el botón */
    margin-top: auto;
    /* Cambio clave: Empujar el botón hacia abajo */
    border-radius: 0;
    /* Opcional: Eliminar bordes redondeados del botón */
    /* height: 100px; */
}

.el-button {
    position: absolute;
    width: 100%;
    top: -50px;
    font-family: 'Roboto', sans-serif;
    background: #174263 url(@/assets/base2.png) !important;
    /* Cambio clave: Ancho completo para el botón */
}
.el-button--danger {
    text-transform: uppercase;
        background: #800322ce url(@/assets/base2.png) !important;
        border-color:#800322ce !important;
}
</style>
